var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-right-content"},[_c('div',{staticClass:"left"},[_vm._t("default")],2),_c('div',{staticClass:"right",style:('width:' + _vm.rightWidth)},[_vm._t("sub")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }